import { Component, Inject } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuditOverviewService } from 'src/app/services/Audit/audit-overview.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

// Dialog component for adding new question
@Component({
  selector: 'app-add-new-question',
  templateUrl: './add-new-question.component.html',
  styleUrls: ['./add-new-question.component.css']
})
export class AddNewQuestionComponent {
  // Required fields for the dialog
  newWeightage: string = '';
  newSubCategory: number = 0;
  newCategory: number = 0;
  newQuestion: string = '';

  addQuestionForm!: FormGroup;
  // Category and subcategory lists
  categories: any;
  subCategories = [];

  constructor(
    private dialog: MatDialog,
    private auditOverviewService: AuditOverviewService,
    private cdr: ChangeDetectorRef,private dialogRef: MatDialogRef<AddNewQuestionComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  ngOnInit(): void {

    this.addQuestionForm = this.formBuilder.group({
      category: ['', Validators.required],
      subCategory: ['', Validators.required],
      question: ['', Validators.required],
      weightage: ['']
    });
    this.getCategories();
    this.getsubCategories();
    // this.getTechnologies();
  }
  // Open dialog to add new question

  // Fetch categories
  getCategories() {
    this.auditOverviewService.getCategoryDropDown().subscribe(
      (response) => {
        if (response?.length > 0) {
          this.categories = response;
        }
      },
      (error) => { console.log(error); }
    );
  }

  // Fetch subcategories
  getsubCategories() {
    this.auditOverviewService.getSubCategoryDropdowns().subscribe(
      (response) => {
        if (response?.length > 0) {
          this.subCategories = response;
        }
      },
      (error) => { console.log(error); }
    )
  }
  // Update category
  updateCategory(value: any) {
    this.newCategory = value.target.value;
  }

  // Update subcategory
  updateSubCategory(value: any) {
    this.newSubCategory = value.target.value;
  }

  // Update question
  updateQuestion(value: any) {
    this.newQuestion = value.target.value;
  }

  // Update weightage
  updateWeightage(event: any) {
    this.newWeightage = event.target.value;
  }
  isPopupOpen = false;
  // Close the dialog without saving
  closeDialog(): void {
    this.isPopupOpen = false;
    document.body.style.overflow = '';
    this.dialogRef.close();
  }

  // Save the new question and close the dialog
  saveDialog(): void {
    if (this.addQuestionForm.invalid) {
      // Iterate over all controls and mark only the invalid ones as touched
      Object.keys(this.addQuestionForm.controls).forEach((field) => {
        const control = this.addQuestionForm.get(field);
        console.log(`${field}: invalid=${control?.invalid}, touched=${control?.touched}`);  
        if (control && control.invalid && !control.touched) {
          control.markAsTouched();
        }
      });
      return;
    }
    this.dialogRef.close({
      newCategory: this.newCategory,
      newSubCategory: this.newSubCategory,
      newQuestion: this.newQuestion,
      newWeightage: this.newWeightage
    });
  }
}

export interface questionType {
  QuestionMappingId: number,
  QuestionId: number,
  categoryId: number,
  SubCategoryId: number,
  QuestionText: string,
  weightage: string,
  priorityOrder: number,
  isActive: boolean
}